// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__d4Rid","playOverlay":"styles_playOverlay__zpBa6","modalQuestionWrapper":"styles_modalQuestionWrapper__UaJii"};